module.exports = __webpack_public_path__ + "img/DocDrawDemo.56e4dd11.gif";